import {CreateElement} from "../Utilities/CreateElement";
import {DraggableWindow} from "./DraggableWindow";
import {AppMenu} from "./AppMenu";
import {taskManager} from "../globals";
import {ClockWidget} from "./Widgets/Clock";
import {FullscreenWidget} from "./Widgets/FullscreenWidget";
import {Application} from "../Types/Application";
import {Task} from "../System/TaskManager";
import {userConfiguration} from "../../config";

class TaskEntry {
    dom: HTMLElement;
    count: HTMLElement;
    isPinned: boolean;

    constructor(app: Application) {
        const icon = app.icon;
        this.dom = CreateElement(`
<button type="button" style="height: 100%;" class="btn btn-transparent position-relative p-0 mx-1">
<img style="height: 100%; width: auto" src="${app.icon}" alt="">
</button>`);
        this.count = CreateElement(`<span style="display: none;" class="position-absolute top-0 start-100 translate-middle badge rounded-pill">0</span>`);
        this.dom.appendChild(this.count);
        this.isPinned = false;
    }

    setCount(count: number) {
        this.count.innerText = count.toString();
        if (count === 0) {
            this.count.style.display = 'none';
        } else {
            this.count.style.display = 'block';
        }
    }
}

export class Taskbar {
    dom: HTMLElement;

    startContainer: HTMLElement;
    endContainer: HTMLElement;

    appMenu: AppMenu;

    tasks: Map<string, Array<Task>>;
    taskIcons: Map<string, TaskEntry>;
    taskContainer: HTMLElement;


    constructor() {
        this.dom = CreateElement(`<div id="taskbar" class="fixed-bottom p-1 text-bg-light bg-opacity-75"></div>`);
        const rowContainer = CreateElement(`<div class="row"></div>`)
        this.dom.appendChild(rowContainer);

        this.startContainer = CreateElement(`<div align="left" class="col align-self-start d-inline-flex my-auto"></div>`);
        this.endContainer = CreateElement(`<div align="right" class="col align-self-end justify-content-end d-inline-flex align-items-center my-auto"></div>`);

        rowContainer.appendChild(this.startContainer);
        rowContainer.appendChild(this.endContainer);


        this.appMenu = new AppMenu();
        this.appMenu.render(this.startContainer);

        new ClockWidget().render(this.endContainer);
        new FullscreenWidget().render(this.endContainer);

        this.taskContainer = CreateElement(`<div class="col" style="height: 42px;"></div>`);
        this.startContainer.appendChild(this.taskContainer);
        this.taskIcons = new Map<string, TaskEntry>();
        this.tasks = new Map<string, Array<Task>>();

        userConfiguration.PinnedApplicationProvide().map(application => {
            const dockIcon = new TaskEntry(application);
            dockIcon.isPinned = true;
            this.addTaskEntry(application, dockIcon);
        });

        taskManager.onNewTask(task => {
            const appWindow = <DraggableWindow>task.data;
            const alreadyRunningTask = this.tasks.get(appWindow.app.id);
            if (typeof appWindow.id === "string") {
                if (alreadyRunningTask !== undefined) {
                    alreadyRunningTask.push(task);
                    const taskEntry = this.taskIcons.get(appWindow.app.id);
                    if (taskEntry !== undefined) {
                        taskEntry.setCount(alreadyRunningTask.length);
                    }
                } else {
                    this.tasks.set(appWindow.app.id, new Array<Task>(task));
                    let taskEntry = this.taskIcons.get(appWindow.app.id);
                    if (taskEntry === undefined) {
                        taskEntry = new TaskEntry(appWindow.app);
                    }
                    if (!taskEntry.isPinned) {
                        this.addTaskEntry(appWindow.app, taskEntry);
                    }
                    taskEntry.setCount(1);
                }
            }
        });
        taskManager.onRemoveTask(task => {
            const appWindow = <DraggableWindow>task.data;
            let appTasks = this.tasks.get(appWindow.app.id);
            if (appTasks !== undefined) {
                appTasks = appTasks.filter(t => t.id !== task.id);
                const taskIcon = this.taskIcons.get(appWindow.app.id);
                if (taskIcon !== undefined) {
                    taskIcon.setCount(appTasks.length);
                }
                if (appTasks.length === 0) {
                    if (taskIcon !== undefined) {
                        if (!taskIcon.isPinned) {
                            this.removeTaskEntry(taskIcon);
                        }
                    }
                    this.tasks.delete(appWindow.app.id);
                } else {
                    this.tasks.set(appWindow.app.id, appTasks);
                }

            }
        })
    }

    addTaskEntry(application: Application, taskEntry: TaskEntry): TaskEntry {
        this.taskIcons.set(application.id, taskEntry);
        this.taskContainer.appendChild(taskEntry.dom);

        taskEntry.dom.addEventListener('click', () => {
            const allWindowsOfApplication = this.tasks.get(application.id);
            if (allWindowsOfApplication !== undefined) {
                const firstWindow = <DraggableWindow>allWindowsOfApplication[0].data;
                const isHidden = firstWindow.hidden;
                allWindowsOfApplication.forEach(task => {
                    const taskWindow = <DraggableWindow>(task.data);
                    taskWindow.hide(!isHidden);
                })
            } else if (taskEntry.isPinned) {
                taskEntry.setCount(1);
                const draggableWindow = new DraggableWindow(application);
                const task = taskManager.addTask(draggableWindow);
                draggableWindow.onclose = (force): boolean => {
                    taskManager.removeTask(task.id);
                    return false;
                }
            }
        });

        return taskEntry;
    }

    removeTaskEntry(taskEntry: TaskEntry) {
        this.taskContainer.removeChild(taskEntry.dom);
    }

    render(container: HTMLElement) {
        container.appendChild(this.dom);
    }
}